import { Box, Button, Card, CardActions, CardContent, Grid, Typography } from "@mui/material";
import React from "react";
import ComboCryptoCoins from "../ComboCryptoCoins";
import ComboNetwork from "../ComboNetwork";

const styleButton = {
	backgroundColor: "#027af2",
	color: "#FFFFFF",
	height: "50px",
	width: "200px",
	textTransform: "capitalize",
	"&:hover": {
		color: "#FFFFFF",
		backgroundColor: "#003399",
	},
};

const CryptoSelect = ({ setCryptoCurrency, cryptoCurrency, setNetwork, network, title, setStep, token }) => {
	const nextStep = (e) => {
		setStep(2);
	};

	let isMobile = false;

	if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
		isMobile = true;
	}

	return (
		<Grid sx={{ width: isMobile ? "100%" : 500 }}>
			<Card>
				<CardContent>
					<Typography component="h2" variant="h6" sx={{ mb: 2 }}>
						{title}
					</Typography>
					<ComboCryptoCoins setCryptoCurrency={setCryptoCurrency} cryptoCurrency={cryptoCurrency} setNetwork={setNetwork} token={token} />
					<ComboNetwork setNetwork={setNetwork} network={network} cryptoCurrency={cryptoCurrency} />
				</CardContent>
				<CardActions>
					<Box sx={{ alignItems: "center", alignContent: "center", textAlign: "center", width: "100%", paddingBottom: 4, paddingTop: 2 }}>
						<Button size="large" variant="extended" sx={styleButton} onClick={nextStep} disabled={network === null}>
							GENERATE ADDRESS
						</Button>
					</Box>
				</CardActions>
			</Card>
		</Grid>
	);
};

export default CryptoSelect;
